import './ListActionsDropdown.scss'

import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import { CoreConstants } from 'hb4e-ui-core'
import { Icon, Popover, Modal, useConfirm } from 'hb4e-ui-core-ui'
import { HasPermission } from 'hb4e-ui-authentication'

import EditListForm from './EditListForm/EditListForm'
import DuplicateListToEducatorForm from './DuplicateListToEducatorForm/DuplicateListToEducatorForm'
import { deleteList } from '../../../actions'
import { urlListView } from '../../../urls'

const { PERM_SHARE_LIST } = CoreConstants

const ListActionsDropdown = ({ list }) => {
  const dispatch = useDispatch()

  const [isActionsDropdownOpen, setIsActionsDropdownOpen] = useState(false)
  const [isEditDetailsModalOpen, setIsEditDetailsModalOpen] = useState(false)
  const [isDuplicateToEducatorModalOpen, setIsDuplicateToEducatorModalOpen] = useState(false)

  const navigate = useNavigate()
  const { confirm: confirmDeleteList } = useConfirm({
    title: 'Delete List',
    prompt: 'Are you sure you’d like to delete this List?',
    cancelLabel: 'Cancel',
    confirmLabel: 'Yes, Delete List',
  })

  const handleEditDetailsButtonClick = () => {
    setIsActionsDropdownOpen(false)
    setIsEditDetailsModalOpen(true)
  }

  const handleDuplicateToEducatorButtonClick = () => {
    setIsActionsDropdownOpen(false)
    setIsDuplicateToEducatorModalOpen(true)
  }

  const handleDeleteListButtonClick = async () => {
    setIsActionsDropdownOpen(false)

    if (await confirmDeleteList()) {
      await dispatch(deleteList(list.getServerID()))

      navigate(urlListView(), { replace: true })
    }
  }

  const handleModalOnClose = () => {
    setIsEditDetailsModalOpen(false)
    setIsDuplicateToEducatorModalOpen(false)
  }

  const renderModal = () => {
    const isModalOpen = isEditDetailsModalOpen || isDuplicateToEducatorModalOpen
    let modalTitle = ''
    let formToRender = null

    if (isEditDetailsModalOpen) {
      modalTitle = 'Edit List'
      formToRender = <EditListForm onClose={handleModalOnClose} list={list} />
    } else if (isDuplicateToEducatorModalOpen) {
      modalTitle = 'Duplicate to Educator'
      formToRender = <DuplicateListToEducatorForm onClose={handleModalOnClose} list={list} />
    }

    return (
      <Modal
        title={modalTitle}
        isOpen={isModalOpen}
        onClose={handleModalOnClose}
        className="list-actions-dropdown__actions-modal"
      >
        {formToRender}
      </Modal>
    )
  }

  return (
    <div className="list-actions-dropdown">
      <Popover
        placement={Popover.Placement.BOTTOM}
        isOpen={isActionsDropdownOpen}
        onClose={() => setIsActionsDropdownOpen(false)}
      >
        <Popover.Target>
          <button
            aria-label={`${list.getName()}, list actions`}
            onClick={() => setIsActionsDropdownOpen(!isActionsDropdownOpen)}
            aria-expanded={isActionsDropdownOpen}
            aria-controls="list-actions-dropdown__actions-list"
          >
            <Icon.CircleChevronDownSolid
              className="list-actions-dropdown__dropdown-button-icon"
              rotation={isActionsDropdownOpen ? [Icon.Effect.ROTATE_180] : 0}
            />
          </button>
        </Popover.Target>

        <Popover.Content>
          <ul id="list-actions-dropdown__actions-list">
            <li className="list-actions-dropdown__dropdown-list-item">
              <button
                className="list-actions-dropdown__dropdown-list-item-button"
                onClick={handleEditDetailsButtonClick}
              >
                Edit Details
              </button>
            </li>
            {/* TODO: This button was hidden as part of HEET-122 until the completion of HEET-37 */}
            {/* <HasPermission permission={[PERM_SHARE_LIST]}>
              <li className="list-actions-dropdown__dropdown-list-item">
                <button
                  className="list-actions-dropdown__dropdown-list-item-button"
                  onClick={handleDuplicateToEducatorButtonClick}
                >
                  Duplicate to Educator
                </button>
              </li>
            </HasPermission> */}
            <li className="list-actions-dropdown__dropdown-list-item">
              <button
                className="list-actions-dropdown__dropdown-list-item-button"
                onClick={handleDeleteListButtonClick}
              >
                Delete List
              </button>
            </li>
          </ul>
        </Popover.Content>
      </Popover>

      {renderModal()}
    </div>
  )
}

export default ListActionsDropdown
